import React, { PureComponent } from 'react';
import history from '../../core/history';
import './PageNotFound.scss';

class PageNotFound extends PureComponent {
  render() {
    return (
      <div className="ndp-error align-container">
        <div className="align-inner">
          <p className="title">404 / Page Not Found</p>
          <p>
            The link you clicked may be broken
            <br />
            or the page may have been removed.
          </p>
          <a className="btn btn-primary" onClick={(e) => {
            e.preventDefault();
            history.push("/")
          }}>
            Go back home
          </a>
        </div>
      </div>
    );
  }
}

export default PageNotFound;
